import { CommonQuestionListVO, CommonQuestionVO } from '@domain/vo/pass/interview/question/CommonQuestionVO';
import { CompanyQuestionListRs, CompanyQuestionRs } from '@domain/rs/pass/interview/question/CompanyQuestionRs';
import { QuestionType } from '@domain/constant/questionType';
import { JobTypeCode } from '@domain/constant/v1/jobType';
import { JobGroupCode } from '@domain/constant/filterType';

export class CompanyQuestionVO extends CommonQuestionVO {
  type: QuestionType.COMPANY;
  companySn: number;
  companyName: string;
  jobTypeCode: JobTypeCode;
  jobGroupCode: JobGroupCode;

  constructor(rs: CompanyQuestionRs) {
    super(rs);
    this.type = QuestionType.COMPANY;
    this.companySn = rs.companySn;
    this.companyName = rs.companyName;
    this.jobTypeCode = rs.jobTypeCode;
    this.jobGroupCode = rs.jobGroupCode;
  }
}

export class CompanyQuestionListVO extends CommonQuestionListVO {
  questions: CompanyQuestionVO[];

  constructor(rs: CompanyQuestionListRs) {
    super(rs);
    this.questions = rs.questions.map((question) => new CompanyQuestionVO(question));
  }
}
